export default __webpack_public_path__ + "static/media/birdie.75802351.JPG";